import { Component, OnInit } from "@angular/core";
import { StudentMaster } from "../model/StudentMaster.model";
import { AuthService } from "../service/auth.service";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { SessionClient } from "../configration/sessionclient.storage";
import { User } from "../model/User.model";
import Swal from "sweetalert2";
import { MainserviceService } from "../service/mainservice.service";
import { MessageService } from "primeng/api";

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.scss"],
})
export class RegisterComponent implements OnInit {
  studentMaster: StudentMaster = new StudentMaster();

  user: User = new User();
  otppage: boolean = true;

  seconds: number;
  minute: number;

  interval;
  timeCompleted: boolean = false;
  errorEmail: string = "";
  errorPhone: string = "";

  errorBean: any = {};
  constructor(
    private authService: AuthService,
    private mainService: MainserviceService,
    private router: Router,
    private sessionClient: SessionClient,
    private messageService: MessageService
  ) {}

  ngOnInit() {}

  floatClass(type: string) {
    if (type == "name") {
      document.getElementById("floatname").style.transform =
        "translateX(6px) scale(0.7)";

      document.getElementById("floatname").style.transition = "0.5s";
      document.getElementById("mobileinputname").focus();
    } else if (type == "phone") {
      document.getElementById("floatphone").style.transform =
        "translateX(6px) scale(0.7)";
      document.getElementById("floatphone").style.transition = "0.5s";
      document.getElementById("mobileinputphone").focus();
    } else if (type == "email") {
      document.getElementById("floatemail").style.transform =
        "translateX(6px) scale(0.7)";
      document.getElementById("floatemail").style.transition = "0.5s";
      document.getElementById("mobileinputemail").focus();
    }
  }

  navigateLogin() {
    this.router.navigateByUrl("/login");
  }

  // *******************************register*************************************8
  saveStudent() {
    if (
      this.user.otp == null ||
      this.user.otp == undefined ||
      this.user.otp == ""
    ) {
      this.errorBean.invalidotp = true;

      return;
    }
    if (this.user.otp != this.user.actualOtp) {
      this.errorBean.invalidotp = true;

      return;
    }

    this.errorBean.invalidotp = false;

    this.messageService.add({
      severity: "success",
      summary: "Registration Successful",
      detail: "",
    });

    this.saveStudentMaster();
  }

  getToken() {
    // this.studentMaster.user.username=this.user.phone.toString();

    this.authService.attemptAuth(this.user).subscribe(
      (data) => {
        this.sessionClient.saveToken(data.token);
        this.getStudentDetailsByUsername();
      },
      (err: HttpErrorResponse) => {
        if (err.status === 200) {
          //json circular break at server side always add
          //extra information of timestamp and status along with
          //main json so parsing occurs still at status 200
          // this.router.navigateByUrl('/');
          //  this.redirection();
        } else {
          // alert('token api not successful')
          return;
        }
      }
    );
  }

  getStudentDetailsByUsername() {
    this.studentMaster.user = this.user;

    this.mainService
      .getStudentDetailsByUsername(this.studentMaster)
      .subscribe((data) => {
        this.studentMaster = data;
        this.authService.setUserSession(this.studentMaster);
        this.router.navigateByUrl("/student-dashboard");
      });
  }

  startTimer() {
    this.timeCompleted = false;
    this.seconds = 0;
    this.minute = 1;
    this.interval = setInterval(() => {
      if (this.seconds > 0) {
        this.seconds--;
      } else if (this.seconds == 0) {
        this.minute--;
        this.seconds = 59;

        if (this.minute < 0) {
          this.seconds = 0;
          this.minute = 0;

          this.pauseTimer();
        }
      } else {
        this.seconds = 10;
      }
    }, 1000);
  }

  pauseTimer() {
    clearInterval(this.interval);
    this.timeCompleted = true;
  }

  sendOTP() {
    let errorFlag = false;

    if (this.user.name == null || this.user.name == "") {
      this.errorBean.name = true;
      errorFlag = true;
    } else {
      this.user.name = this.user.name.trim();
      this.errorBean.validNameMsg = "Please enter a valid name";
      if (this.user.name == "") {
        this.errorBean.validName = true;
        errorFlag = true;
      } else {
        const pattern = /^[a-zA-Z\s,.'-]*$/;

        if (!pattern.test(this.user.name)) {
          this.errorBean.validName = true;
          errorFlag = true;
        } else {
          this.errorBean.name = false;
          this.errorBean.validName = false;
        }
      }
    }

    if (this.user.email == null || this.user.email == "") {
      this.errorBean.email = true;
      this.errorEmail = "* Please enter email";
      errorFlag = true;
    } else {
      if (!this.isValid(this.user.email)) {
        this.errorBean.email = true;
        this.errorEmail = "* Please enter a valid email";
        errorFlag = true;
      } else {
        this.errorBean.email = false;
      }
    }

    if (this.user.phone == null) {
      this.errorBean.phone = true;
      this.errorPhone = "* Please enter Phone number";
      errorFlag = true;
    } else if (
      this.user.phone.toString().length > 10 ||
      this.user.phone.toString().length < 10
    ) {
      this.errorBean.phone = true;
      this.errorPhone = "* A phone number must include 10 digits";
      errorFlag = true;
    } else {
      this.errorBean.phone = false;
    }

    if (errorFlag) {
      return;
    }

    this.authService.checkDuplicateEmailAndMobileNo(this.user).subscribe(
      (data) => {},
      (err: HttpErrorResponse) => {
        if (err.status === 200) {
          let jsonString = err.error.text;

          if (jsonString === "NO-DUP") {
            this.authService.sendOtpToUser(this.user).subscribe(
              (data) => {
                this.user.actualOtp = data;
                // this.user.otp = this.user.actualOtp;
                this.errorBean.phone = false;
                this.errorBean.email = false;
                this.errorEmail = "";
                this.errorPhone = "";
                this.otppage = false;
                this.startTimer();

                // this.fetchUserDetails(false);
              },
              (err: HttpErrorResponse) => {
                if (err.status === 200) {
                  let jsonString = err.error.text;
                  // alert(jsonString);
                  this.otppage = false;

                  //json circular break at server side always add
                  //extra information of timestamp and status along with
                  //main json so parsing occurs still at status 200

                  //  this.redirection();
                }
              }
            );

            // this.displayregisterotp = false;
          } else if (jsonString === "INVALID-EMAIL") {
            this.errorBean.email = true;
            this.errorEmail = "* Please enter a valid email";
            return;
            // this.displayregisterotp = false;
            // alert("enter valid email id");
          } else if (jsonString === "PHONE-DUP") {
            this.errorBean.phone = true;
            this.errorPhone = "* Duplicate Phone number entered";
            return;
            // this.displayregisterotp = false;
            // alert("duplicate mobile number");
          } else if (jsonString === "INVALID-PHONE") {
            // alert(" Invalid mobile number");
            this.errorPhone = "* Please enter a valid Mobile number";
            this.errorBean.phone = true;
            return;
            // this.displayregisterotp = false;
          } else if (jsonString === "EMAIL-PHONE-DUP") {
            // alert(" Invalid mobile number");
            this.errorPhone = "* Duplicate Phone number entered";
            this.errorEmail = "* Duplicate Email Id entered";
            this.errorBean.phone = true;
            this.errorBean.email = true;
            return;
            // this.displayregisterotp = false;
          } else if (jsonString === "EMAIL-DUP") {
            // alert("Duplicate  email");
            this.errorEmail = "* Duplicate Email Id entered";
            this.errorBean.email = true;
            return;
            // this.displayregisterotp = false;
          } else if (jsonString === "DUP-USERNAME") {
            // alert("Duplicate  email");
            Swal.fire({
              title: "Error",
              text: "Duplicate username!",
              icon: "error",
              showCancelButton: true,
              showConfirmButton: true,
            });
            return;
            // this.displayregisterotp = false;
          }

          //json circular break at server side always add
          //extra information of timestamp and status along with
          //main json so parsing occurs still at status 200

          // this.router.navigateByUrl('/login');

          //  this.redirection();
        }
      }
    );

    // this.opnsendotp= true;
  }

  isValid(email) {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var resp = re.test(String(email).toLowerCase());
    return resp;
  }

  saveStudentMaster() {
    let user = new User();
    user.name = this.user.name;
    user.email = this.user.email;
    user.phone = this.user.phone;

    this.studentMaster.user = user;

    this.mainService.saveStudentMaster(this.studentMaster).subscribe(
      (data) => {
        this.studentMaster = data;
        this.user.username = this.studentMaster.user.username;

        this.getToken();

        // this.router.navigateByUrl('/');
        //   setTimeout(()=>{
        //     window.location.reload();
        // }, 500);
      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage("error", "Something went wrong", "");
            //  this.spinnerService.hide();
          }
        }
      }
    );
  }
  // login
}
